import {
    SET_ACTIVE_PANEL_TABS,
    SET_DASHBOARD_FILTERS,
    SET_LOADING_PANEL,
    SET_METRIC_DATA,
    SET_METRIC_DATA_LOADING,
    SET_VIEW_STATE_LOADING,
    SET_VIEW,
    SET_WIDGET_FILTERS,
} from './reducerConstants';
import { formatViewConfiguration } from '../dashboardUtils';
import { updateMetricData } from '../utils/metricRequestUtils';

export function getInitialDashboardState(
    viewConfiguration,
    selectOptions,
    dashboardKey,
    viewOptions
) {
    const activePanelTabs = viewOptions.reduce(
        (result, viewOption) => ({ ...result, [viewOption.viewKey]: {} }),
        {}
    );

    return {
        activePanelTabs,
        dashboardKey,
        error: null,
        isMetricDataLoading: false,
        loadingPanel: null,
        lastViewedTimestamps: {},
        ...formatViewConfiguration(viewConfiguration, selectOptions),
    };
}

// eslint-disable-next-line complexity
export default function dashboardReducer(state, action) {
    switch (action.type) {
        case SET_DASHBOARD_FILTERS:
            return {
                ...state,
                ...action.payload,
                areDashboardFiltersLoading: true,
            };
        case SET_WIDGET_FILTERS:
            return {
                ...state,
                widgets: action.payload,
            };
        case SET_VIEW:
            return {
                ...state,
                ...action.payload,
                isViewStateLoading: false,
            };
        case SET_METRIC_DATA:
            return {
                ...state,
                areDashboardFiltersLoading: false,
                isMetricDataLoading: false,
                metricData: updateMetricData(
                    state.metricData,
                    action.payload.metricData,
                    action.payload.resetAllData
                ),
                lastViewedTimestamps: action.payload.lastViewedTimestamps,
                loadingPanel: null,
            };
        case SET_ACTIVE_PANEL_TABS:
            return {
                ...state,
                activePanelTabs: action.payload,
            };
        case SET_METRIC_DATA_LOADING:
            return {
                ...state,
                isMetricDataLoading: true,
            };
        case SET_VIEW_STATE_LOADING:
            return {
                ...state,
                isViewStateLoading: true,
            };
        case SET_LOADING_PANEL:
            return {
                ...state,
                loadingPanel: action.payload,
            };
        default: {
            // eslint-disable-next-line no-console
            console.warning(
                `${action.type} is not defined in the dashboard reducer`
            );
            return state;
        }
    }
}
